import { ReferenceValue } from '../reference/reference.model';

export const getReferenceValue = (key: string, referenceList: ReferenceValue[]): string => {
  const reference = referenceList.find(reference => reference.key === key);
  return reference ? reference.value : key;
};
